import { Component, computed, OnInit, ViewChild } from '@angular/core';

import { SupportGerenciarVendedoresInternoComponent } from '../../support/_componentes/gerenciar-vendedores/gerenciar-vendedores-interno.component';
import { UserService } from 'app/_services/user.service';

@Component({
    selector: 'app-gerenciar-vendedores', templateUrl: './gerenciar-vendedores.component.html', styleUrls: ['./gerenciar-vendedores.component.scss'],
    standalone: false
})
export class PartManagerGerenciarVendedoresComponent implements OnInit {
    @ViewChild(SupportGerenciarVendedoresInternoComponent) interno: SupportGerenciarVendedoresInternoComponent;

    holdingSelecionada: any;
    holdingSelecionadaId: number;

    userIsBillable = computed(() => {
        const user = this.userService.user();
        if (!user) return null;

        return user?.selectedUser?.is_billable ?? user.is_billable;
    });

    constructor(private userService: UserService) { }

    ngOnInit(): void {
        this.carregarTela();
    }

    carregarTela() {
        this.holdingSelecionada = { id: this.userService.holdingId(), is_billable: this.userIsBillable() };
        this.holdingSelecionadaId = this.holdingSelecionada.id;

        setTimeout(() => this.interno.listarEmpresasAssociadas(this.holdingSelecionada.id, this.holdingSelecionada.is_billable), 500);
    }

    exportarCSV() {
        this.interno.exportarCSV();
    }
}
